import { cn } from '@/lib/cn';
import { sessionSettingsMobileModalOpenAtom } from '@heidi/session';
import { useSetAtom } from 'jotai/index';
import { ChevronLeft, X } from 'lucide-react';
import React from 'react';

interface MobileModalNavBarProps {
  title?: React.ReactNode;
  onClose: () => void;
  changeBackButton?: () => void;
  disableAutomaticHiding?: boolean;
}

const MobileModalNavBar = ({
  title,
  onClose,
  changeBackButton,
  disableAutomaticHiding = false,
}: MobileModalNavBarProps) => {
  const setSessionSettingsMobileModalOpen = useSetAtom(
    sessionSettingsMobileModalOpenAtom
  );
  const handleBackClick = () => {
    return () => {
      if (changeBackButton) {
        changeBackButton();
      } else {
        onClose();
        setTimeout(() => {
          setSessionSettingsMobileModalOpen(true);
        }, 100);
      }
    };
  };
  return (
    <div
      className={cn(
        'flex w-full flex-row justify-between px-2 pt-2',
        !disableAutomaticHiding && 'sm:hidden'
      )}
    >
      {title ? (
        title
      ) : (
        <ChevronLeft
          className={'size-6 cursor-pointer text-text-secondary rtl:-scale-x-100'}
          onClick={handleBackClick()}
        />
      )}
      <X className={'size-6 cursor-pointer text-text-secondary'} onClick={onClose} />
    </div>
  );
};

export default MobileModalNavBar;
